import Vue from 'vue';
import PreviewVideo from '@/components/copyright/basics/previewVideo/index.vue'
let $vm

const plugin = {
  install (vue, pluginOptions = {}) {
    const TsaPreviewVideo = vue.extend(PreviewVideo)
    if (!$vm) {
      $vm = new TsaPreviewVideo({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const previewVideo = {
      show (options = {}) {
        $vm.show = true
        $vm.playerOptions.sources[0].src = options.src
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaPreviewVideo) {
      vue.prototype.$TsaPreviewVideo = previewVideo
    }
  }
}
export default plugin